import { showUserAlert } from "../utils/userErrorMessage";
// src/pages/DriversList.jsx
import React, { useEffect, useState } from "react";
import Header from "../Component/Header";
import { supabase } from "../supabase/client";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { useNavigate } from "react-router-dom";

export default function DriversList() {
  const navigate = useNavigate();

  // 검색 상태
  const [filters, setFilters] = useState({ car_number: "", driver_name: "" });

  // 데이터 상태
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    try {
      const company = localStorage.getItem("email");
      // 1) 드라이버 목록
      let q = supabase
        .from("profiles")
        .select("id, driver_name, hire_date, phone, email, car_number")
        .eq("role", "driver")
        .eq("company", company);

      if (filters.car_number) q = q.ilike("car_number", `%${filters.car_number}%`);
      if (filters.driver_name) q = q.ilike("driver_name", `%${filters.driver_name}%`);

      q = q.order("driver_name", { ascending: true }).order("car_number", { ascending: true });

      const { data: drivers, error: dErr } = await q;

      if (dErr) throw dErr;

      setRows(drivers || []);
    } catch (e) {
      showUserAlert("조회 실패: " + e.message);
      setRows([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 최초 1회

  const onSearch = () => fetchData();

  return (
    <div className="space-y-1">
      <style>{`
        .drivers-list-table th,
        .drivers-list-table td {
          text-align: center;
        }

        .drivers-list-table .col-seq {
          width: 48px;
          min-width: 48px;
          white-space: nowrap;
        }

        .drivers-list-table .col-driver {
          width: 76px;
          min-width: 76px;
          white-space: nowrap;
          word-break: keep-all;
        }

        .drivers-list-table .col-date {
          width: 104px;
          min-width: 104px;
          white-space: nowrap;
        }

        .drivers-list-table .col-wide {
          width: 190px;
          min-width: 190px;
        }
      `}</style>
      <Header />

      <div className="px-4 pt-1 pb-4 space-y-4">
        <h2 className="text-lg font-semibold">기사 정보</h2>

        {/* 검색 영역 */}
        <div className="flex flex-wrap gap-2 items-center">
          <Input
            placeholder="차량번호"
            className="w-40"
            value={filters.car_number}
            onChange={(e) => setFilters((p) => ({ ...p, car_number: e.target.value }))}
          />
          <Input
            placeholder="기사명"
            className="w-40"
            value={filters.driver_name}
            onChange={(e) => setFilters((p) => ({ ...p, driver_name: e.target.value }))}
          />
          <Button onClick={onSearch} disabled={loading}>
            {loading ? "검색중..." : "검색"}
          </Button>
        </div>

        {/* 목록 표 */}
        <Card>
          <CardContent className="bg-white">
            <div className="max-h-[70vh] overflow-auto">
              <table className="drivers-list-table table-auto w-full border border-gray-300 text-sm whitespace-nowrap">
                <thead className="sticky top-0 z-30 bg-blue-500 text-white">
                  <tr>
                    {["순번", "기사명", "입사일", "차량 번호", "핸드폰", "기사 메일"].map((h) => (
                      <th
                        key={h}
                        className={
                          "sticky top-0 z-30 border bg-blue-500 p-2 " +
                          (h === "순번" ? "col-seq " : "") +
                          (h === "기사명" ? "col-driver " : "") +
                          (h === "입사일" ? "col-date " : "") +
                          (["핸드폰", "기사 메일", "차량 번호"].includes(h) ? "col-wide " : "")
                        }
                      >
                        {h}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {rows.length === 0 && !loading && (
                    <tr>
                      <td className="border p-3 text-center text-gray-500" colSpan={6}>
                        데이터가 없습니다.
                      </td>
                    </tr>
                  )}

                  {rows.map((r, idx) => (
                      <tr key={r.id}>
                        {/* 순번(클릭 시 수정 화면으로 이동) */}
                        <td className="border p-2 col-seq">
                          <button
                            className="text-blue-600 underline"
                            onClick={() => navigate(`/drivers/${r.id}/edit`)}
                          >
                            {idx + 1}
                          </button>
                        </td>
                        <td className="border p-2 col-driver">{r.driver_name || ""}</td>
                        <td className="border p-2 col-date">{(r.hire_date || "").slice(0, 10)}</td>
                        <td className="border p-2 col-wide">{r.car_number || ""}</td>
                        <td className="border p-2 col-wide">{r.phone || ""}</td>
                        <td className="border p-2 col-wide">{r.email || ""}</td>
                      </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* 하단 버튼 */}
            <div className="mt-3 text-left">
              <Button onClick={() => navigate("/drivers/add")}>추가</Button>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
